module.exports = require("paths-exist");